import React from "react";
import { Link, useParams } from "react-router-dom";
import specialOnboardingIcon from "../../../../../assets/images/special-onboarding-icon.svg";
import ROUTE_PATHS from "../../../../../utils/routePaths";
import CommercialAirlineNavigationBar from "../../../../../components/element/CommercialAirlineNavigationBar";

const EscortDetailsHeader = () => {
  const { flightNumber } = useParams();

  return (
    <CommercialAirlineNavigationBar
      title={"Special Onboarding"}
      navigationLogo={specialOnboardingIcon}
      backContent={
        <div className="navigation-header">
          <Link
            to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
            className="navigation-header-link"
          >
            Home/
          </Link>
          <Link
            to={ROUTE_PATHS.COMMERCIAL_AIRLINE_VIEW_SPECIAL_ONBOARDING}
            className="navigation-header-link"
          >
            Special Onboarding/
          </Link>
          <Link
            to={
              ROUTE_PATHS.COMMERCIAL_AIRLINE_VIEW_SPECIAL_ONBOARDING_TRIP_DETAILS
            }
            className="navigation-header-link"
          >
            {`${flightNumber}/`}
          </Link>
          Special Onboarding
        </div>
      }
    />
  );
};

export default EscortDetailsHeader;
